<template>
  <div
    class="login-page"
    :class="{ 'bg-white': $vuetify.breakpoint.width <= 1280 }"
    style="background-color: black;"
  >
    <v-container class="no-top-nav no-side-space" xs12 sm6>
      <div class="login-outer">
        <div :class="{ 'login-view': $vuetify.breakpoint.width > 1280 }">
          <v-btn
            v-if="$vuetify.breakpoint.width > 1280"
            icon
            class="absolute ma-0 btn-close"
            style="color: white"
            @click="$router.push(`/`)"
          >
            <v-icon class="font-size-34" style="background-color: black;">close</v-icon>
          </v-btn>
          <div class="auth">
            <div v-if="loginAuth === 'login'">
              <login-input :showForgotPassword="showForgotPassword" />
            </div>

            <div
              v-if="loginAuth === 'forgotPassword'"
              class="forgot-password-input"
            >
              <div class="intro-text text-xs-center">
                <h2>Forgot Password</h2>
              </div>

              <forgot-password-input :showLogin="showLogin" />
            </div>

          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import LoginInput from "@/views/auth/loginInput";
import forgotPasswordInput from "@/views/auth/forgotPasswordInput/";

export default {
  name: "LoginPage",
  components: {
    LoginInput,
    forgotPasswordInput,
  },
  data() {
    return {
      loginAuth: "login",
    };
  },
  created() {
    if (this.$store.state.auth.user != null) {
      this.$router.push({ name: "UserSettings" });
    }
  },
  mounted () {
    $(".content").css("background", "black")
  },
  beforeDestroy() {
    $(".content").css("background", "");
  },
  computed: {
    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    showForgotPassword() {
      this.loginAuth = "forgotPassword";
    },
    showLogin() {
      this.loginAuth = "login";
      this.activeView = "loginView";
    },
  },
};
</script>

<style lang="scss" scoped>
.login-view {
  margin-top: 90px;
}
.login-outer {
  min-height: 85vh;
  display: flex;
  justify-content: center;
}
.btn-close {
  position: absolute;
  top: 20px;
  right: 20px;
}

@media screen and (max-width: 1280px) {
  .auth {
    width: 100% !important;
    box-shadow: none !important;
  }

  .no-top-nav {
    padding: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?51787d2e